'use client';

import { cn } from '@bridebook/aura';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { forwardRef, ElementRef, ComponentPropsWithoutRef, useMemo } from 'react';
import { SelectorButtonGroupContext } from './selector-button-group-context';
import { type SelectorButtonSize } from './selector-button-presentation';
import { cva } from 'class-variance-authority';

const selectorButtonGroupVariants = cva('grid grid-cols-2 gap-3', {
  variants: {
    sm: {
      true: 'flex flex-wrap',
      false: '',
    },
  },
});

type SelectorButtonGroupElement = ElementRef<typeof ToggleGroupPrimitive.Root>;
type SelectorButtonGroupProps = ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root> & {
  size?: SelectorButtonSize;
};

export const SelectorButtonGroup = forwardRef<SelectorButtonGroupElement, SelectorButtonGroupProps>(
  ({ className, children, size = 'standard', ...props }, ref) => {
    const contextValue = useMemo(
      () => ({
        size,
      }),
      [size],
    );

    return (
      <SelectorButtonGroupContext.Provider value={contextValue}>
        <ToggleGroupPrimitive.Root
          ref={ref}
          className={cn(selectorButtonGroupVariants({ sm: size === 'sm', className }))}
          {...props}>
          {children}
        </ToggleGroupPrimitive.Root>
      </SelectorButtonGroupContext.Provider>
    );
  },
);

SelectorButtonGroup.displayName = 'SelectorButtonGroup';
